import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';//em transito
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import EventBusyIcon from '@material-ui/icons/EventBusy';//inderefiras
import EventNoteIcon from '@material-ui/icons/EventNote';//analise
import EventIcon from '@material-ui/icons/Event';//concluidas
import { deepOrange, green } from '@material-ui/core/colors';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import Tooltip from '@material-ui/core/Tooltip';
import Cardtransferir from './cardtransferir';
import Grid from '@material-ui/core/Grid';
import Cardselectmotora from './cardselectmotoraecia';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import { dateTimePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';
import { DateTimePicker } from '@material-ui/pickers';
import Cardmap from './apmap';
import Minhalocation from '../testmap/localizaapp';
import Cardmaproute from './aproute';
import { ControlPointDuplicateOutlined } from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import SpeedIcon from '@material-ui/icons/Speed';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import {useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    alignContent:'LEFT',
  },
  menuButton: {
    //marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  datas:{
    alignItems: 'center',
    marginTop: theme.spacing(2),

  },
  rounded: {
    color: green[500],
    //backgroundColor: green[500],
  },
  rounded2: {
    color: red[500],
    //backgroundColor: green[500],
  },
  rounded3: {
    color: green[500],
    //backgroundColor: green[500],
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */

var adm=false;
var tipodesloc;
 export default function RecipeReviewCard(props) {
  let history = useHistory();

  //******************************** */
  function localiza() {
    console.log("locsaliza successfully updated!", props.props[0].id);
  
  if (navigator && navigator.geolocation) {
    navigator.geolocation.watchPosition(pos => {
      const coords = pos.coords;
      /*this.setState({
        currentLocation: {
          lat: coords.latitude,
          lng: coords.longitude
        }
      });

      //************************ */
      console.log("id", props.props[0].id);
      console.log("id", props.props[0].id);
      var unit = firebase.firestore().collection("agenda").doc(props.props[0].id).collection('posicao').doc();

    
      unit.set({latitude:coords.latitude, longitude:coords.longitude, datahora:firebase.firestore.Timestamp.fromDate(new Date())})
  .then(() => {
    console.log("locsaliza successfully updated!", props.props);
    
  })
  .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });


      //*********************** */

    });
  }
}


  //******************************** */

  const[stid, setaid]=React.useState('');
  const[datahoraretorno, setadatahoraretorno]=React.useState('');
  const[dataretornoreal, setadataretornoreal]=React.useState();
  const[datahorasaida, setadatahorasaida]=React.useState('');
  const[datahorasaidareal, setadatahorasaidareal]=React.useState('');
  const[depsolicitente, setadepsolicitante]=React.useState('');
  const[dsolicitacao, setadsolicitacao]=React.useState('');
  const[nomesolicitante, setanomesolicitante]=React.useState('');
  const[lotacaosolicitante, setalotacaosolicitante]=React.useState('');
  const[telefonesolicitante, setatelefonesolicitante]=React.useState('');
  const[objetivo, setaobjetivo]=React.useState('');
  const[nsolicitacao, setansolicitacao]=React.useState('');
  const[npassageiro, setanpassageiro]=React.useState('');
  const[siapesolicitente, setasiapesolicitente]=React.useState('');
  const[listaparadasvolta, setalistaparadasvolta]=React.useState(['']);
  const[listaparadasida, setalistaparadasida]=React.useState(['']);
  const[listapassageiros, setalistapassageiros]=React.useState(['']);
  const[localdestino, setalocaldestino]=React.useState('');
    const[localsaida, setalocalsaida]=React.useState('');
    const[localdestinomapa, setalocaldestinomapa]=React.useState(['']);
  const[localsaidamapa, setalocalsaidamapa]=React.useState(['']);
  const[geolocalsaidamapa, setageolocalsaidamapa]=React.useState(['']);
  const[temporetorno, setatretorno]=React.useState('');
  const[geolocaldestinomapa, setageolocaldestinomapa]=React.useState(['']);
  const[campisolicitante, setacampisolicitante]=React.useState('');
  const[observacao, setaobservacao]=React.useState('');
  //const[anexos, setaanexos]=React.useState('');
  const[autorizacoes, setaautorizacoes]=React.useState([]);
  const[tipodeslocamento, setatipodeslocamento]=React.useState('');
  const[tipodesl, setatipodesl]=React.useState(0);
  const[nomerespdespesas, setanomerespdespesas]=React.useState('');
  const[fonerespdespesas, setafonerespdespesas]=React.useState('');
  const[stdivdespesas, setastdivdespesas]=React.useState(true);
  const[stdivcontroles, setastdivcontroles]=React.useState(true);
  const[stbttransferir, setastbttransferir]=React.useState(true);
  const[stbtdeferirmento, setastbtdeferirmento]=React.useState(false);
  const[stbtindeferirmento, setastbtindeferirmento]=React.useState(true);
  const[unidadetransferencia, setaunidadetransferencia]=React.useState('');
  const[kilometragem, setakilometragem]=React.useState('');
  const[passageiros, setapassageiros]=React.useState('');
  const[anexo, setaanexo]=React.useState([]);
  const[rdespesas, setardespesas]=React.useState(1);
  const [motorista, setamotorista]=React.useState('');
  const [veiculo, setaveiculo]=React.useState('');
  const [status, setastatus]=React.useState('');
  const [statuschecklist, setastatuschecklist]=React.useState(false);
  const [kminicio, setakminicio]=React.useState();
 
 
//********************objeto veiculo******************* */

const [itemagenda, setitemagenda] = React.useState([]);


var respdesp;
var pagina;
React.useEffect(()=>{
  setitemagenda(props.props);
  console.log("item agend props ", props.props)
},[props])

React.useEffect(() => {
  console.log("item agend props ", props.usertipo)
  
  

    
var dt='';
var datar='' ;
itemagenda.forEach(modelo=>(dt=modelo.datahoraretorno));
console.log("Documentuswss data updated!", dt);
if (dt!=undefined) {
  setadataretornoreal(dt);
  datar= new Date(dt.seconds*1000).toLocaleString("pt-BR");
  console.log("Documentuswss data updated!", datar);
  console.log("Document data updated!", datar);
}
//
var id='';
itemagenda.forEach(modelo=>(id=modelo.id));

setaid(id);

var st='';
itemagenda.forEach(modelo=>(st=modelo.status));
var stcheck;
itemagenda.forEach(modelo=>(stcheck=modelo.statuschecklist));
console.log("autorizacoes ",aut)
if(stcheck!=undefined){
  setastatuschecklist(stcheck);
}

var kinicio;
itemagenda.forEach(modelo=>(kinicio=modelo.kminicio));

if(kinicio!=undefined){
  setakminicio(kinicio);
}

setastatus(st);
if(st=='deferido'){
    setastbtiniciar(false)
    setastbttransito(true)
}else{
    if(st=='transito'){
      localiza();
        setastbtiniciar(true)
        setastbttransito(false)
        if((stcheck==undefined)||(stcheck==false)){
          handleClickopendchecklist();
        }
    }
}



setadatahoraretorno(datar);
var dts='';
var datas=''
itemagenda.forEach(modelo=>(dts=modelo.datahorasaida));
if (dts!=undefined) {
  setadatahorasaidareal(dts);
  datas= new Date(dts.seconds*1000).toLocaleString("pt-BR");
  
}
setadatahorasaida(datas);
var depsol;
itemagenda.forEach(modelo=>(depsol=modelo.depsolicitacao));
console.log('valor do stateauco ',depsol);
if(depsol!=undefined){
  console.log('valor do stateauco ',depsol[0].nomedepsol);
setadepsolicitante(depsol[0].nomedepsol);
}

itemagenda.forEach(modelo=>(tipodesloc=modelo.tipodeslocamento));
console.log('valor do stateauco ',tipodesloc);
setatipodesl(tipodesloc)
if(tipodesloc==1){
  setatipodeslocamento('Deslocamento Interno')
}else{
  if(tipodesloc==2){
    setatipodeslocamento('Viagem')
   
itemagenda.forEach(modelo=>(respdesp=modelo.respdespesas));
console.log('responsavel' ,respdesp);
if((respdesp!='')||(respdesp!=undefined)){
  setardespesas(respdesp)
}
    var nomerespdesp;
itemagenda.forEach(modelo=>(nomerespdesp=modelo.nomerespdespesas));
setanomerespdespesas(nomerespdesp);
var fonerespdep;
itemagenda.forEach(modelo=>(fonerespdep=modelo.fonerespdespesas));
setafonerespdespesas(fonerespdep);
setastdivdespesas(false);
  }
}

var km ='';
itemagenda.forEach(modelo=>(km=modelo.totalkm))
setakilometragem(km);

var ps ='';
var pss='';
itemagenda.forEach(modelo=>(ps=modelo.listapassageiros))
for (let index = 0; index < ps.length; index++) {
  pss = pss  + ps[index].passageiro.nome + ', ';
  console.log("psssss " + ps[index])
  console.log("psssss " , pss)
}
setapassageiros(pss);



var dsol ='';
itemagenda.forEach(modelo=>(dsol=modelo.dsolicitacao))
setadsolicitacao(dsol);
var nomesol=';'
itemagenda.forEach(modelo=>(nomesol=modelo.nomesolicitante))
setanomesolicitante(nomesol);
var cp ='';
itemagenda.forEach(modelo=>(cp=modelo.campisolicitante))
setacampisolicitante(cp);
var telsol = '';
itemagenda.forEach(modelo=>(telsol=modelo.telefonesolicitante))
setatelefonesolicitante(telsol);
var obj = '';
itemagenda.forEach(modelo=>(obj=modelo.objetivo))
setaobjetivo(obj);
var nsol = '';
itemagenda.forEach(modelo=>(nsol=modelo.nsolicitacao))
//setlot(lota);
setansolicitacao(nsol);
var np='';
itemagenda.forEach(modelo=>(np=modelo.npassageiro))
setanpassageiro(np);
var siapesol='';
itemagenda.forEach(modelo=>(siapesol=modelo.siapesolicitente))
setasiapesolicitente(siapesol);
var obs = '';
itemagenda.forEach(modelo=>(obs=modelo.observacao))
setaobservacao(obs);
var aut = '';

itemagenda.forEach(modelo=>(aut=modelo.autorizacoes));
console.log("autorizacoes ",aut)
if((aut!=undefined)&&(aut!='')){
  setaautorizacoes(aut);
}




/*
itemagenda.forEach(modelo=>(listaparadas=modelo.listaparadas))
//setlot(lota);
itemagenda.forEach(modelo=>(listapassageiros=modelo.listapassageiros))
//setlot(lota);
*/
var dest='';
itemagenda.forEach(modelo=>(dest=modelo.localdestino))
setalocaldestinomapa(dest);
setalocaldestino(dest.description);
console.log('destino', localdestino )
var saida='';
itemagenda.forEach(modelo=>(saida=modelo.localsaida));
setalocalsaidamapa(saida);
setalocalsaida(saida.description);

var pida='';
itemagenda.forEach(modelo=>(pida=modelo.listaparadasida));
if((pida!='')&&(pida!=null)&&(pida!=undefined)){
  setalistaparadasida(pida);
}
//setalistaparadasida(pida);
var volta='';
itemagenda.forEach(modelo=>(volta=modelo.listaparadasvolta));
setalistaparadasvolta(volta);

var ane='';
itemagenda.forEach(modelo=>(ane=modelo.anexo));
if((ane!='')&&(ane!=undefined)){
  console.log("arquivo ", ane)
  const storageRef = firebase.storage().ref();
  const storageRefChild = storageRef.child('anexosagenda/' + id + '/' + ane);
  console.log("arquivo ", storageRefChild.name);
  //console.log("arquivo ", input)

  storageRefChild.getDownloadURL().then(function (url) { 
    // O url de serviço pode ser inserido em um <img> 
    //var img = document.getElementById ('muimui'); 
    console.log("arquivo ", url)
    //var img = url;
    setaanexo([{nome: ane, link: url}])
   // var link_item = document.getElementById('download-link')
   // link_item.setAttribute('href', url)
   // alert('uri anexo', img); 

  }) 
  .catch (function (err) { 
    console.log('Anexado'); 
  })


}


 
  var m='';
  itemagenda.forEach(modelo=>(m=modelo.motorista));
  setamotorista(m);
  if((m!='')&&(m!=undefined)){
    setavermotorista(m.label);
  }
  var v='';
  itemagenda.forEach(modelo=>(v=modelo.veiculo));
  setaveiculo(v);
  if((v!='')&&(v!=undefined)){
    setaverveiculo(v.label);
  }

 

},[itemagenda]);

//**********************************pegar anexos */



//*********************///*/
const[stbtiniciar, setastbtiniciar]=React.useState(false);
const[stbttransito, setastbttransito]=React.useState(true);

const[stbdeslocamento, setastbdeslocamento]=React.useState(false);
const[stbintervalo, setastbintervalo]=React.useState(false);
const[stbtrefeicao, setastbtrefeicao]=React.useState(false);
const[stbtturno, setastbtturno]=React.useState(false);


const[kmtotal, setakm]=React.useState();
const[vermotorista, setavermotorista]=React.useState('');
const[verveiculo, setaverveiculo]=React.useState('');







var listaassina 
const handleiniciar  =()=>{
  
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Iniciou do Atendimento',
    datahora:firebase.firestore.Timestamp.fromDate(new Date())
  }
  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
  console.log("Document autorizacao updated!", listaassina);
  
 

     
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({statusmotorista:true, status:'transito'})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtiniciar(true);
      setastbttransito(false);
      handleassina();
      alert("Jornada Iniciada");
     handleClickopendchecklist();
      //******************* */
      var unitb = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
      unitb.set({nomeassina:props.usernome,marcacao:'Início da Jornada',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
     .then(() => {
       console.log("Document successfully updated!");
       history.push("/consultarMotoristaTransito");
       //setastbdeslocamento(true);
      // handleassina();
       //alert("Inicio do Deslocamento");
     })
     .catch((error) => {
         // The document probably doesn't exist.
         console.error("Error updating document: ", error);
     });

//*************************** */
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    


const handleassina=()=>{

  console.log("Document autorizacao aqui!", autorizacoes);
  var unit = firebase.firestore().collection("agenda").doc(stid);
  return unit.update({autorizacoes: listaassina})
.then(() => {
  console.log("Document autorizacao updated!");
})
.catch((error) => {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
});
}

const handleconcluir =()=>{
  var statusadm;

  if(((tipodesloc==1)&&(adm))||( (tipodesloc==2)&&(props.usertipo==11))){
    statusadm='supervisao';
  }else{
      statusadm='unidadetransporte'
  }

    
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Término do Atendimento',
    datahora:firebase.firestore.Timestamp.fromDate(new Date())
  }
  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
  console.log("Document autorizacao updated!", listaassina);
    
     
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({kmfinal:kmfinal, statusmotorista:false, statusadm:statusadm})
    .then(() => {
      console.log("Document successfully updated!");
      setastbttransito(false);
      handleassina();
      
      alert("Solicitação Concluída", );
      history.push("/PageInit");
      //******************* */
      var unitb = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
      unitb.set({nomeassina:props.usernome,marcacao:'Término da Jornada',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
     .then(() => {
       console.log("Document successfully updated!");
       //setastbdeslocamento(true);
      // handleassina();
       //alert("Inicio do Deslocamento");
     })
     .catch((error) => {
         // The document probably doesn't exist.
         console.error("Error updating document: ", error);
     });

//*************************** */

    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    

    }

    

  
//******************************** */
const handleiniciodeslocamento  =()=>{
    
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Iniciou o Deslocamento',
    datahora:firebase.firestore.Timestamp.fromDate(new Date())
  }
  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
  console.log("Document autorizacao updated!", listaassina);
    
     
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({nomeassina:props.usernome,marcacao:'Início do Deslocamento',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbdeslocamento(true);
      handleassina();
      alert("Inicio do Deslocamento");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
//******************************** */
const handleterminodeslocamento =()=>{
    
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Concluiu o Deslocamento',
    datahora:firebase.firestore.Timestamp.fromDate(new Date())
  }
  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
  console.log("Document autorizacao updated!", listaassina);
    
      
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'Término deslocamento',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbdeslocamento(false);
      handleassina();
      alert("Deslocamento Concluído");
//******************************* */
var unitb = firebase.firestore().collection("agenda").doc(stid);
return unitb.update({statususer:false})
.then(() => {
  console.log("concluiu")
}).catch((error) => {
  // The document probably doesn't exist.
  console.error("Error updating document: ", error);
});
//**************************** */

    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
    
//******************************** */
const handleiniciointervalo =()=>{
    
  //var lc = Minhalocation(stid);
  
  
  
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'inicio intervalo descanso',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbintervalo(true);
      
      alert("Iniciou Intervalo de Descanso");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
//******************************** */
const handleterminointervalo =()=>{
    
 
  
  
  
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'termino intervalo descanso',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbintervalo(false);
      
      alert("Terminou Intervalo de descanso");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
    //******************************** */
const handleiniciorefeicao =()=>{
    
 
  
  
 
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'inicio parada refeição',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtrefeicao(true);
      
      alert("Iniciou Intervalo para Refeição");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
//******************************** */
const handleterminorefeicao =()=>{
    
 
  
  
 
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'termino parada refeição',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtrefeicao(false);
      
      alert("Terminou Intervalo para Refeição");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
const[stregocorrencia, setastregocorrencia]=React.useState('')
const handleocorrencia =()=>{
  
    
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'atualizaçao'

  }
/*
  var db=firebase.firestore();
  var washingtonRef = db.collection("agenda").doc("stid");

  washingtonRef.update({
    autorizacoes: firebase.firestore.FieldValue.arrayUnion(assina)
});

  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);*/
  console.log("Document autorizacao updated!", listaassina);
    
      if(props.usertipo==11){
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('ocorrencias').doc();

        
      unit.set({nomeassina:props.usernome,ocorrencia:stregocorrencia,datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      
     // handleassina();
      handleClosedopenregocorrencia();
      alert("Ocorrência Registrada");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    }

    //************************************************ */

  const [openregocorrencia, setaopenregocorrencia] = React.useState(false);

  const handleClickopenregocorrencia = () => {
    setaopenregocorrencia(true);
  };

  const handleClosedopenregocorrencia = () => {
    setaopenregocorrencia(false);
  };

//******************************** */
 
//******************************** */
const handleinicioturno =()=>{
    
 
  
  
  
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'inicio turno de trabalho',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtturno(false);
      
      alert("Inicio Turno de trabalho");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */
const handleterminoturno =()=>{
    
 
  
  
 
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('marcacoes').doc();

        
        unit.set({marcacao:'termino turno de trabalho',datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtturno(true);
      
      alert("Término Turno de trabalho");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
//******************************** */











     


//const [stveiculo,setaveiculo]=React.useState();
const setatemporetorno=(props)=>{
  var hretorno = new Date();//dataretornoreal;
  var hretorno= new Date(dataretornoreal.seconds*1000);//.toLocaleString("pt-BR");
 // alert (dataretornoreal);

  var atraso = props+300;

  hretorno.setSeconds(hretorno.getSeconds() + atraso);
  setatretorno(hretorno.toLocaleString("pt-BR"))
  //setadataretornoreal(hretorno)
  //alert (hretorno);
}











      
                    //********************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [condicao, setacondicao] = React.useState([]);
  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    
  }};

  //**************** */
  //************************************************ */

  const [opendchecklist, setopendchecklist] = React.useState(false);

    const handleClickopendchecklist = () => {
      setopendchecklist(true);
    };

    
  
    const handleClosedopendchecklist = () => {


     
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('checklist').doc();

        
        unit.set({stmotoretc:stmotoretc, relmotor:relmotor, stpneu:stpneu, relpneu:relpneu, stsinal:stsinal ,
          relsinal:relsinal, stmacaco:stmacaco, relmacaco:relmacaco, star:star, relar:relar ,stextintor:stextintor,
          relextintor:relextintor, stcinto:stcinto, relcinto:relcinto,  stvel:stvel, relvel:relvel, stlaudo:stlaudo,
          rellaudo:rellaudo, stlimpa:stlimpa , rellimpa:rellimpa, relobs:relobs})
    .then(() => {

      
      console.log("Document successfully updated!");
      //setastbtturno(false);
      setopendchecklist(false);
      alert("CheckList Salvo");
      //**************** */
      var unitd = firebase.firestore().collection("agenda").doc(stid);
      return unitd.update({kminicio:kminicio, statuschecklist:true})
    .then(() => {
      console.log("Document autorizacao updated!");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
      //**************** */
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    

      
    };

    //**************************** */
   
    const [kmfinal, setakmfinal]=React.useState('');
    
    //**************************** */

    //**************************** */
    const[stmotoretc, setamotoretc]=React.useState('1');
    const [relmotor, setarelmotor]=React.useState('');
    const handlemotoretc=(event)=>{
      setamotoretc(event.target.value);
    }
    //**************************** */

      //**************************** */
      const[stpneu, setapneu]=React.useState('1');
      const [relpneu, setarelpneu]=React.useState('');
      const handlepneu=(event)=>{
        setapneu(event.target.value);
      }
      //**************************** */

       //**************************** */
       const[stsinal, setasinal]=React.useState('1');
       const [relsinal, setarelsinal]=React.useState('');
       const handlesinal=(event)=>{
         setasinal(event.target.value);
       }
       //**************************** */

        //**************************** */
        const[stmacaco, setamacaco]=React.useState('1');
        const [relmacaco, setarelmacaco]=React.useState('');
        const handlemacaco=(event)=>{
          setamacaco(event.target.value);
        }
        //**************************** */

        
        //**************************** */
        const[star, setar]=React.useState('1');
        const [relar, setarelar]=React.useState('');
        const handlear=(event)=>{
          setar(event.target.value);
        }
        //**************************** */

         //**************************** */
         const[stextintor, setaextintor]=React.useState('1');
         const [relextintor, setarelextintor]=React.useState('');
         const handleextintor=(event)=>{
           setaextintor(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stcinto, setacinto]=React.useState('1');
         const [relcinto, setarelcinto]=React.useState('');
         const handlecinto=(event)=>{
           setacinto(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stvel, setavel]=React.useState('1');
         const [relvel, setarelvel]=React.useState('');
         const handlevel=(event)=>{
           setavel(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stlaudo, setalaudo]=React.useState('1');
         const [rellaudo, setarellaudo]=React.useState('');
         const handlelaudo=(event)=>{
           setalaudo(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stlimpa, setalimpa]=React.useState('1');
         const [rellimpa, setarellimpa]=React.useState('');
         const handlelimpa=(event)=>{
           setalimpa(event.target.value);
         }
         //**************************** */

         //**************************** */
         const [relobs, setarelobs]=React.useState('');
         //**************************** */

         //************************************** */
         const [open, setOpen] = React.useState(false);
         

         const handleClickOpen = () => {
           setOpen(true);
         };
       
        
         //************************************* */

         const [opengeracusto, setaopengeracusto] = React.useState(false);

         const handleClosegeroucusto = () => {
          

          
          adm= true;
          handleconcluir();
          setaopengeracusto(false);
           
          
         };

         const handleClosesemcusto= () => {
          adm = false;
          
          
          handleconcluir();
          setaopengeracusto(false);
        };


         //************************************* */

          //************************************* */

          const [openkmfinal, setaopenkmfinal] = React.useState(false);

          const handleClickOpenkmfinal = () => {
            setaopenkmfinal(true);
          };

          const handleClosekmfinal = () => {
          if(kmfinal>=kminicio) {
         if(props.usertipo==17){
          handleconcluir();
          setaopenkmfinal(false);
         }else{
           if((tipodesl==1)&&(props.usertipo==11)){
            setaopenkmfinal(false);
            setaopengeracusto(true);
           }else{
            handleconcluir();
            setaopenkmfinal(false);
           }
         }
        }else{
          alert("A quilometragem final deve ser maior ou igual a inicial")
        }
             
            
           
          };
 
          
          //************************************* */
        

  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             title= {nsolicitacao}
             subheader= {dsolicitacao}
     
           />
           <CardContent>



           <Dialog open={opendchecklist} variant="outlined" onClose={''} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">CheckList</DialogTitle>
        <DialogContent>
          <DialogContentText>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setakminicio(e.target.value)}
          type=""
          fullWidth
          id="kminicio"
          label="Quilometragem inicial"
          name="kminicio"  
          value={kminicio}    
         
          />
          <br></br>
          <br></br>
         
          <FormControl component="fieldset">
              <FormLabel component="legend">Motor: óleo do motor; níveis de água do radiador; fluído de freio; fluído de embreagem; fluído de direção.</FormLabel>
      <RadioGroup aria-label="gender" name="gender1" value={stmotoretc} onChange={handlemotoretc}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>
    

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelmotor(e.target.value)}
          type=""
          fullWidth
          id="motor"
          label="Descrição - Relato"
          name="observacao"  
          value={relmotor}    
         
          />
          <br></br>
          <br></br>

        <FormControl component="fieldset">
              <FormLabel component="legend">Estado dos pneus; calibragem.</FormLabel>
      <RadioGroup aria-label="gender" name="gender2" value={stpneu} onChange={handlepneu}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelpneu(e.target.value)}
          type=""
          fullWidth
          id="pneu"
          label="Descrição - Relato"
          name="observacao"  
          value={relpneu}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Sinalização (faróis, lanternas, piscas).</FormLabel>
      <RadioGroup aria-label="gender" name="gender3" value={stsinal} onChange={handlesinal}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelsinal(e.target.value)}
          type=""
          fullWidth
          id="sinal"
          label="Descrição - Relato"
          name="observacao"  
          value={relsinal}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Macaco; estepe; triângulo; chave de roda.</FormLabel>
      <RadioGroup aria-label="gender" name="gender5" value={stmacaco} onChange={handlemacaco}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelmacaco(e.target.value)}
          type=""
          fullWidth
          id="macaco"
          label="Descrição - Relato"
          name="observacao"  
          value={relmacaco}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Ar-condicionado.</FormLabel>
      <RadioGroup aria-label="gender" name="gender6" value={star} onChange={handlear}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelar(e.target.value)}
          type=""
          fullWidth
          id="ar"
          label="Descrição - Relato"
          name="observacao"  
          value={relar}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Extintor.</FormLabel>
      <RadioGroup aria-label="gender" name="gender7" value={stextintor} onChange={handleextintor}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelextintor(e.target.value)}
          type=""
          fullWidth
          id="extintor"
          label="Descrição - Relato"
          name="observacao"  
          value={relextintor}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Cinto de segurança; buzina; espelhos retrovisores.</FormLabel>
      <RadioGroup aria-label="gender" name="gender8" value={stcinto} onChange={handlecinto}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelcinto(e.target.value)}
          type=""
          fullWidth
          id="cinto"
          label="Descrição - Relato"
          name="observacao"  
          value={relcinto}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Tacógrafo; velocímetro.</FormLabel>
      <RadioGroup aria-label="gender" name="gender9" value={stvel} onChange={handlevel}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelvel(e.target.value)}
          type=""
          fullWidth
          id="vel"
          label="Descrição - Relato"
          name="observacao"  
          value={relvel}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Laudo LIT-ANTT (coletivos).</FormLabel>
      <RadioGroup aria-label="gender" name="gender10" value={stlaudo} onChange={handlelaudo}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarellaudo(e.target.value)}
          type=""
          fullWidth
          id="laudo"
          label="Descrição - Relato"
          name="observacao"  
          value={rellaudo}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Limpeza do veículo </FormLabel>
      <RadioGroup aria-label="gender" name="gender11" value={stlimpa} onChange={handlelimpa}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="Boa" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="Ruim" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarellimpa(e.target.value)}
          type=""
          fullWidth
          id="limpa"
          label="Descrição - Relato"
          name="observacao"  
          value={rellimpa}  
          
         
          />
          <br></br>
          <br></br>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelobs(e.target.value)}
          type=""
          fullWidth
          id="obs"
          label="Observações"
          name="observacao"  
          value={relobs}    
          multiline
          rows={4}  
          />
          <br></br>
          <br></br>

          

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClosedopendchecklist} color="primary" >
            Salvar
          </Button>
          </DialogActions>
      </Dialog>

      


      <Dialog
        open={opengeracusto}
        
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Gerou Custo"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Este deslocamento gerou hora extra ou adicional noturno?
            (Deslocamentos realizados entre 22 horas e 5 horas da manhã geram adicional noturno)
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosegeroucusto} color="primary">
            Sim
          </Button>
          <Button onClick={handleClosesemcusto} color="primary" autoFocus>
            Não
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openkmfinal}
        
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Quilometragem Final"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           
          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setakmfinal(e.target.value)}
          type=""
          fullWidth
          id="kmfinal"
          label="Quilometragem final"
          name="kmfinal"  
          value={kmfinal}    
         
          />
           
           </DialogContentText>
        </DialogContent>
        <DialogActions>
         
         
          <Button onClick={handleClosekmfinal} color="primary" autoFocus>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>


      
           
           
                <Typography variant="body2" color="textSecondary" component="p">
               {campisolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {depsolicitente}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Nome Solicitante: {nomesolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {tipodeslocamento}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Objetivo: {objetivo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Quilometragem: {kilometragem} metros
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Veículo: {verveiculo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Motorista: {vermotorista}
             </Typography>

                         
             <TextField
            className={classes.datas}
         id="datetimeini2"
        label="Data e hora da Saída"
        disabled={true}
        value={datahorasaida}
        />
         <TextField
             className={classes.datas}
             id="datetimeini"
            label="Data e hora do Retorno"
            disabled={true}
            
            value={datahoraretorno}
            />
            
             
             
            <div hidden={stbtiniciar}>
           
           <Button
           
       variant="contained"
       color="secondary"
       startIcon={<SpeedIcon />}
       onClick={handleiniciar}
       className={classes.menuButton}
       >
       Iniciar Atendimento
       </Button>
          
          
       
                  </div>
                  <div hiden={stbttransito}>
       {/*}
                  <Button
       variant="contained"
       color="secondary"
       
       onClick={handleClickopenregocorrencia}//{handleClickopenocorrencia}
       className={classes.menuButton}
       >
       Registrar Ocorrência
       </Button>
       
       <div hidden={stbdeslocamento}> 
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleiniciodeslocamento}
       className={classes.menuButton}
       >
       Iniciar delocamento
       </Button>
       </div>
       
       <div hidden={!stbdeslocamento}>
       
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleterminodeslocamento}
       className={classes.menuButton}
       >
       Concluir deslocamento
       </Button>
       </div>
       
       <div hidden={stbintervalo}>
       
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleiniciointervalo}
       className={classes.menuButton}
       >
       Parada intervalo
       </Button>
       </div>
       
       
       
       
       <div hidden={!stbintervalo}>
       
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleterminointervalo}
       className={classes.menuButton}
       >
       Retorno intervalo
       </Button>
       </div>
       
       
       
       <div hidden={stbtrefeicao}>
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleiniciorefeicao}
       className={classes.menuButton}
       >
       Parada Refeiçao
       </Button>
       </div>
       
       
       <div hidden={!stbtrefeicao}>
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleterminorefeicao}
       className={classes.menuButton}
       >
       Retorno Refeiçao
       </Button>
       </div>
       
       
       <div hidden={stbtturno}>
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleterminoturno}
       className={classes.menuButton}
       >
       Término Turno de trabalho
       </Button>
       </div>
       
       
       <div hidden={!stbtturno}>
       <Button
       variant="contained"
       color="secondary"
       
       onClick={handleinicioturno}
       className={classes.menuButton}
       >
       Retorno Turno de trabalho
       </Button>
       </div>
       
       */}
       <Button
       variant="contained"
       color="secondary"
       startIcon={<DoneAllIcon />}
       onClick={handleClickOpenkmfinal}
       className={classes.menuButton}
       >
       Concluir Atendimento
       </Button>
       
       
       
       
       
       </div>


       <Dialog open={openregocorrencia} variant="outlined" onClose={handleClosedopenregocorrencia} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Registrar Ocorrência</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setastregocorrencia(e.target.value)}
          type="Float"
          fullWidth
          id="valortotal"
          label="Ocorrência"
          name="observacao"  
             multiline
             rows={5}
        
          />

         
                 

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
            <Button variant="contained" onClick={handleocorrencia} color="primary" >
            Salvar
          </Button>
           
          <Button variant="contained" onClick={handleClosedopenregocorrencia} color="primary" >
            Cancelar
          </Button>
          </DialogActions>
      </Dialog>
       

           </CardContent>

          
            <CardActions disableSpacing>

           
           
             
           <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
           

           
     
             
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
              
               <Cardmap  localsaida={localsaidamapa}  localdestino={localdestinomapa} listaparadasida={listaparadasida}
               listaparadasvolta={listaparadasvolta}              />

                
                       <br></br>    


             <Typography variant="body2" color="textSecondary" component="p">
               Nº Passageiros: {npassageiro}
               <br></br>
               {passageiros}
               
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Observações: {observacao}
             </Typography>
             
              { anexo.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                  Anexo:
                  <br></br>
                <Link  href={item.link} target="_blank" rel="noopener">{item.nome}</Link>
                </Typography>
              ))

              }
               
             <Typography variant="body2" color="textSecondary" component="p">
               Autorizações: 

               </Typography>
                 
                 
               {autorizacoes.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                Nome: {item.nomeassina}
                <br></br>
                Siape: {item.siapeassina}
                <br></br>
                {item.acao}
                <br></br>
              </Typography>
                 
              ))}
             
            
              
     
             </CardContent>

            
             <CardActions disableSpacing>
            
            
                
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
         </Card>
  );
}
